import React from "react";

const EnlumiIcon = () => {
  return (
    <svg
      width="101"
      height="32"
      viewBox="0 0 101 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6804_134991)">
        <path d="M101 0.702148H92.4387V31.2998H101V0.702148Z" fill="#7647EE" />
        <path
          d="M48.1875 6.08952V0.702148H39.6263V12.79V13.6635V15.616V19.6618C39.6391 20.4675 39.553 21.2717 39.3699 22.0561C39.2277 22.6727 38.9381 23.2449 38.5261 23.7229C38.1158 24.1728 37.5957 24.5068 37.0176 24.6915C36.4022 24.9002 35.6509 25.0049 34.7639 25.0056C33.8769 25.0063 33.1257 24.9016 32.5102 24.6915C31.9323 24.5064 31.4123 24.1725 31.0017 23.7229C30.5901 23.2448 30.3008 22.6726 30.159 22.0561C29.975 21.2718 29.8885 20.4676 29.9015 19.6618V15.616V13.6635V12.6117V0.702148H21.3413V6.08952V17.2544C21.3413 19.7949 21.578 21.997 22.0513 23.8607C22.5246 25.7243 23.3 27.258 24.3774 28.4618C25.4541 29.6668 26.842 30.5578 28.5409 31.1347C30.2398 31.7115 32.3131 32 34.7609 32C37.2094 32 39.2827 31.7115 40.981 31.1347C42.6792 30.5578 44.067 29.6668 45.1444 28.4618C46.2211 27.258 46.9965 25.7243 47.4705 23.8607C47.9445 21.997 48.1812 19.7949 48.1805 17.2544V6.08952H48.1875Z"
          fill="#7647EE"
        />
        <path
          d="M8.56123 24.5973V0.702148H0V22.9072C0 25.6274 0.684528 27.7062 2.05357 29.1437C3.42262 30.5811 5.57239 31.2998 8.5029 31.2998H19.8287V24.5973H8.56123Z"
          fill="#7647EE"
        />
        <path
          d="M85.758 2.59388C84.0819 0.866651 81.7585 0.00202647 78.7878 0C77.3215 0 76.0872 0.194542 75.0849 0.583625C74.1654 0.923211 73.3138 1.42631 72.5707 2.06902C71.932 2.6257 71.4023 3.2979 71.0089 4.05091C70.673 4.68904 70.4108 5.36387 70.2275 6.06218H69.7659C69.5862 5.37083 69.3438 4.69758 69.0419 4.05091C68.6877 3.29687 68.1859 2.62273 67.5666 2.06902C66.9109 1.46716 66.0819 0.972031 65.0795 0.583625C64.0772 0.195218 62.8433 0.00067549 61.3777 0C58.1381 0 55.6601 1.05917 53.9438 3.1775C52.2275 5.29584 51.3703 8.5892 51.3723 13.0576V31.2958H59.9335V11.5377C59.9335 7.92451 61.0713 6.11758 63.3468 6.1169C64.388 6.1169 65.159 6.44722 65.6598 7.10785C66.1606 7.76848 66.411 8.68039 66.411 9.84358V17.0831H73.5845V9.85574C73.5845 7.36994 74.6065 6.12669 76.6507 6.12602C78.6949 6.12534 79.7167 7.36859 79.716 9.85574V30.1964V31.3039H88.2772V10.1476C88.2752 6.84306 87.4355 4.32516 85.758 2.59388Z"
          fill="#7647EE"
        />
      </g>
      <defs>
        <clipPath id="clip0_6804_134991">
          <rect width="101" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnlumiIcon;
